import React from 'react';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';

import { useUpsertConversation } from '../../../redux/hooks/answer/conversation-hooks';
import { useAppDispatch } from '../../../redux/hooks/app-hooks';
import { setActiveConversationId } from '../../../redux/slices/chat-tab/chat-tab-slice';

export type UseChatBoostModeButtonParams = {
    question: string;
};

export const useChatBoostModeChatMessageButton = ({ question }: UseChatBoostModeButtonParams) => {
    const { t } = useTranslation('translations');
    const dispatch = useAppDispatch();
    const upsertConversation = useUpsertConversation();

    const onClick: React.MouseEventHandler = React.useCallback(
        async (e) => {
            if (e instanceof MouseEvent) {
                e.stopPropagation();
            }

            const conversationId = v4();

            await upsertConversation({ conversationId, content: question, boostMode: true });

            dispatch(setActiveConversationId(conversationId));
        },
        [dispatch, question, upsertConversation]
    );

    return {
        onClick,
        enabled: true,
        disabled: !question,
        label: t('chat.deep-search'),
    };
};
